import { withErrorBoundary } from '@s4l/utils/hocs/withErrorBoundary'
import React, { useState } from 'react'
import { ListOfProperty } from '@s4l/stayforlong/property/ListOfProperty'

import styles from './styles.module.css'
import { useS4LContext } from '@s4l/react-context'
import PropertyCard from '../PropertyCard'
import { Typography } from '@s4l/ds'
import { Image } from '../../index'

export interface LastSeenGridProps {
  lastSeenPropertiesJSON: ReturnType<ListOfProperty['toJSON']>
}

function LastSeenGrid({ lastSeenPropertiesJSON }: Readonly<LastSeenGridProps>) {
  const { i18n, domain } = useS4LContext()
  const [lastSeenProperties, setLastSeenProperties] = useState(() =>
    ListOfProperty.fromJSONOrEmpty({ json: lastSeenPropertiesJSON })
  )

  if (lastSeenProperties.isEmpty())
    return (
      <div className={styles.noHotelsYetContainer}>
        <Image
          width={144}
          height={144}
          alt={i18n.formatMessage({ id: 'global.no-hotels-seen' })}
          src={`${process.env.NEXT_PUBLIC_CLOUDFRONT_ENDPOINT}/images/illustrations/see.svg`}
        />
        <Typography as="p" variant="body" size="xl" bold>
          {i18n.formatMessage({ id: 'global.no-hotels-seen' })}
        </Typography>
        <Typography as="p" variant="body" size="l">
          {i18n.formatMessage({ id: 'global.no-hotels-seen-body' })}
        </Typography>
      </div>
    )

  const handleRemoveClick = async (
    propertyId: ReturnType<ListOfProperty['toJSON']>['list'][number]['id']
  ) => {
    await domain.RemoveByIDLastSeenPropertyUseCase.execute({ id: propertyId })
    setLastSeenProperties(lastSeenProperties.removeById(propertyId))
  }

  return (
    <div className={styles.propertyContainer}>
      <div className={styles.propertyGrid} data-testid="property-grid">
        {lastSeenProperties.map(property => {
          return (
            <div key={property.id} className={styles.propertyCard} data-property-id={property.id}>
              <PropertyCard variant="fixed-height" propertyJSON={property.toJSON()}>
                <PropertyCard.ActionRemove onClick={() => handleRemoveClick(property.id)} />
              </PropertyCard>
            </div>
          )
        })}
      </div>
    </div>
  )
}

LastSeenGrid.displayName = 'LastSeenGrid'
export default withErrorBoundary(LastSeenGrid)
